import { Component, computed, input, inject, OnInit, signal, LOCALE_ID } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RequestService } from '../../../../services/pharmacy/request.service';
import { PharmacyService } from '../../../../services/pharmacy/pharmacy.service';
import { StatusBadge } from '../../../shared/status-badge/status-badge';
import { RequestLogListItem } from '../../../../services/pharmacy/request.model';
import { COMMENT_VISIBLE_STATUSES } from './view-pharmacy-history.model';
import { finalize } from 'rxjs/operators';
import { Loading } from '../../../../utils/loading/loading';
import { ErrorData } from '../../../../utils/error-data/error-data';
import { EmptyData } from '../../../../utils/empty-data/empty-data';

@Component({
  selector: 'app-view-pharmacy-history',
  standalone: true,
  imports: [CommonModule, DatePipe, StatusBadge, Loading, ErrorData, EmptyData],
  templateUrl: './view-pharmacy-history.html',
  styleUrl: './view-pharmacy-history.scss',
})
export class ViewPharmacyHistory implements OnInit {
  pharmacyId = input.required<number>();
  requestId = input.required<number>();
  currentStatus = input.required<string>();
  isAdmin = input<boolean>(false);

  private requestService = inject(RequestService);
  private pharmacyService = inject(PharmacyService);
  private localeId = inject(LOCALE_ID);

  historyLogs = signal<RequestLogListItem[]>([]);
  pharmacyName = signal<string>('');
  loading = signal<boolean>(true);
  isError = signal<string>('');

  isEmpty = computed(() => !this.loading() && !this.isError() && this.historyLogs().length === 0);

  ngOnInit() {
    this.loadHistory();
  }

  shouldShowComment(status: string): boolean {
    return COMMENT_VISIBLE_STATUSES.includes(status?.toLowerCase());
  }

  getTranslatedTitle(obj: any): string {
    if (!obj) return '';
    return this.localeId.startsWith('ar') ? obj.titleAr : obj.titleEn;
  }

  isArabic(): boolean {
    return this.localeId.startsWith('ar');
  }

  loadHistory() {
    this.loading.set(true);
    this.isError.set('');

    this.requestService
      .getPharmacyRequestLogs(this.pharmacyId())
      .pipe(finalize(() => this.loading.set(false)))
      .subscribe({
        next: (data) => {
          this.historyLogs.set(data.list);
        },
        error: (err) => {
          this.isError.set(this.isArabic() ? err?.messageAr || 'حدث خطأ' : err?.messageEn || 'Something went wrong');
        },
      });

    this.pharmacyService.getPharmacyById(this.pharmacyId()).subscribe((pharmacy) => {
      this.pharmacyName.set(pharmacy.nickName);
    });
  }
}
